module.exports = __webpack_public_path__ + "img/order_completed.f379dded.png";